import Keycloak from './Keycloak.component';
import model from './Keycloak.model';

export * from './utils';
export { Keycloak, model };

export default Keycloak;
